
export function invoiceInfoInterface(data, reverse = false) {
    if (!reverse) {
        return {
            id: data['id'],
            companyName: data['company_name'],
            phone: data['phone'],
            email: data['email'],
            taxCode: data['tax_code'],
            address: data['address'],
            userAhamoveId: data['user_id'],
            childAhamoveId: data['user_arr'],
            nationwide: data['is_nation_wide'],
            splitInvoice: data['is_split_invoice'],
            isParent: data['is_parent'],
            parentId: data['parent_id']
        }
    } else {
        return {
            id: data['id'],
            company_name: data['companyName'],
            phone: data['phone'],
            email: data['email'],
            tax_code: data['taxCode'],
            address: data['address'],
            user_id: data['userAhamoveId'],
            user_arr: data['childAhamoveId'],
            is_nation_wide: data['nationwide'],
            is_split_invoice: data['splitInvoice'],
            is_parent: data['isParent'],
            userAhamoveId: data['user_id'],
            parent_id: data['parentId']
        }
    }

}
